import { create } from "zustand";

export const useLocationStore = create((set) => ({
  locationID: undefined,

  setLocationID: (id) => {
    set(() => ({ locationID: id }));
  },
}));
